var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCounsellingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "145px",
    height: "91px",
    viewBox: "0 0 145 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heads copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.1596847%",
    y1: "83.7378561%",
    x2: "31.4763618%",
    y2: "4.632213%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.1596847%",
    y1: "83.7378561%",
    x2: "31.4763618%",
    y2: "4.632213%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Your-services",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-963.000000, -1233.000000)",
    id: "heads-copy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(963.000000, 1233.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.6371361,38.7177217 C88.821605,38.7177217 94.6457678,44.041894 94.6457678,50.6095934 C94.6457678,53.7925626 93.2778126,56.6834574 91.0500241,58.817777 C91.5449397,60.7045659 92.5255081,61.9991892 93.9903388,62.7008706 C91.6880533,64.1030915 89.3156562,63.7024873 86.8731474,61.4990579 C85.2715575,62.1434828 83.5000784,62.5014651 81.6371361,62.5014651 C74.4526672,62.5014651 68.6285045,57.1772928 68.6285045,50.6095934 C68.6285045,44.041894 74.4526672,38.7177217 81.6371361,38.7177217 Z",
    id: "Combined-Shape",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "head-right",
    transform: "translate(114.666393, 38.580645) scale(-1, 1) translate(-114.666393, -38.580645) translate(84.581359, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9822071,0 L35.1191647,0 C48.784329,1.04246372e-15 59.8621334,11.0778044 59.8621334,24.7429687 L59.8621334,47.0405089 C59.8621334,49.4698714 57.8927459,51.4392589 55.4633834,51.4392589 L49.021607,51.4392589 L49.021607,51.4392589 L49.021607,51.9380385 C49.021607,65.4089176 38.1013018,76.3292228 24.6304227,76.3292228 C11.1595435,76.3292228 0.239238321,65.4089176 0.239238321,51.9380385 L0.239238321,24.7429687 C0.239238321,11.0778044 11.3170428,-1.04246372e-15 24.9822071,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#575756",
    cx: 47.9375544,
    cy: 26.5492949,
    rx: 1.62607896,
    ry: 1.65933093
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.6427122,53.3659766 C71.8271811,53.3659766 77.6513438,58.6901489 77.6513438,65.2578483 C77.6513438,68.4408175 76.2833887,71.3317122 74.0556002,73.4660318 C74.5505158,75.3528208 75.5310841,76.6474441 76.9959149,77.3491255 C74.6936294,78.7513464 72.3212323,78.3507422 69.8787235,76.1473128 C68.2771336,76.7917377 66.5056545,77.14972 64.6427122,77.14972 C57.4582433,77.14972 51.6340805,71.8255477 51.6340805,65.2578483 C51.6340805,58.6901489 57.4582433,53.3659766 64.6427122,53.3659766 Z",
    id: "Combined-Shape",
    fill: "#62EBB9",
    transform: "translate(64.642712, 65.766539) scale(-1, 1) translate(-64.642712, -65.766539) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "head-left",
    transform: "translate(0.000000, 14.648255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.884549,0 L35.0215066,0 C48.6866709,-2.51024996e-15 59.7644753,11.0778044 59.7644753,24.7429687 L59.7644753,47.0405089 C59.7644753,49.4698714 57.7950879,51.4392589 55.3657253,51.4392589 L48.9239489,51.4392589 L48.9239489,51.4392589 L48.9239489,51.9380385 C48.9239489,65.4089176 38.0036437,76.3292228 24.5327646,76.3292228 C11.0618854,76.3292228 0.141580241,65.4089176 0.141580241,51.9380385 L0.141580241,24.7429687 C0.141580241,11.0778044 11.2193847,-4.5951774e-15 24.884549,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#575756",
    cx: 48.9239489,
    cy: 26.5492949,
    rx: 1.62607896,
    ry: 1.65933093
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounsellingIcon);
export default __webpack_public_path__ + "static/media/counselling-icon.8b5ea233f002528420eac7f299c29a4c.svg";
export { ForwardRef as ReactComponent };